import type { ReleasesFilters } from "@services/releases/list/type";

export const STATUS_OPTIONS = [
  {
    value: "pending",
    label: "Pendente",
    style: "bg-yellow-500 hover:bg-yellow-600",
  },
  {
    value: "canceled",
    label: "Cancelada",
    style: "bg-red-600 hover:bg-red-700",
  },
  {
    value: "waiting_ok",
    label: "Aguardando Análise do Admin",
    style: "bg-secondary hover:bg-orange-500",
  },
  {
    value: "concluded",
    label: "Concluída",
    style: "bg-primary hover:bg-teal-600",
  },
  {
    value: "undefined",
    label: "Desconhecido",
    style: "bg-gray-500 hover:bg-gray-600",
  },
];

export const RELEASE_STATUS_MAP = Object.fromEntries(
  STATUS_OPTIONS.map((opt) => [
    opt.value,
    { label: opt.label, style: opt.style },
  ]),
);

export const MENU_STATUS_OPTIONS = [
  ...STATUS_OPTIONS.filter((option) => option.value !== "undefined"),
];

export type Status = (typeof STATUS_OPTIONS)[number]["value"];

export const defaultFilters: ReleasesFilters = {
  startDate: "",
  endDate: "",
  executorId: "",
  status: "",
};
